import { render, staticRenderFns } from "./PanelInputSwitchMini.vue?vue&type=template&id=112853be&scoped=true&"
import script from "./PanelInputSwitchMini.vue?vue&type=script&lang=js&"
export * from "./PanelInputSwitchMini.vue?vue&type=script&lang=js&"
import style0 from "./PanelInputSwitchMini.vue?vue&type=style&index=0&id=112853be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112853be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('112853be')) {
      api.createRecord('112853be', component.options)
    } else {
      api.reload('112853be', component.options)
    }
    module.hot.accept("./PanelInputSwitchMini.vue?vue&type=template&id=112853be&scoped=true&", function () {
      api.rerender('112853be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PanelInputSwitchMini.vue"
export default component.exports